import Bugsnag from '@bugsnag/js';
import { defineBoot } from '@quasar/app-vite/wrappers';
import { Notify } from 'quasar';
import { dayjs } from 'src/services/date';
import storage from 'src/services/storage';
import store from 'src/store';

/**
 * @param {{ router: import('vue-router').Router; }} params
 */
export default defineBoot(({ router }) => {
  store().state.app.onReady.then(() => {
    if (store().getters['session/accountIsDunning'] && !store().getters['session/currentUser'].isIndividual()) {
      dunningMode(router, store);
    }
  });
});

/**
 * @param {import('vue-router').Router} router
 */
export async function dunningMode(router) {
  // Add class to help with styles during dunning state
  document.body.classList.add('account-dunning');

  await store().dispatch('subscriptions/getSubscriptions');

  /** @type {import('src/types/subscription-store').SubscriptionData | null} */
  let closestDunningSub = store().getters['subscriptions/closestDunningSub'];

  if (!closestDunningSub) {
    const account = store().getters['session/account'];
    const { subscription } = account;

    Bugsnag.notify(new Error('Could not find period end in dunning mode'), (event) => {
      event.addMetadata('account subscription', subscription);
      event.addMetadata('subscriptions', store().state.subscriptions.subscriptions);
    });

    closestDunningSub = subscription;
  }

  const endDate = dayjs(closestDunningSub.currentPeriodEndsAt).format('M/D/YYYY');
  const currentUser = store().getters['session/currentUser'];
  const isAdmin = currentUser.isAdmin();

  const actions = [
    {
      label: 'Snooze',
      class: 'q-mr-sm',
      textColor: 'white',
      noCaps: true,
      square: true,
      handler: () => {
        const oneHourFromNow = dayjs().add(1, 'hour').toISOString();
        storage.set('dunning/snooze', oneHourFromNow);
        setTimeout(
          showNotification,
          1000 * 60 * 60 // 1 hour
        );
      },
    },
  ];

  if (isAdmin) {
    actions.push({
      label: 'Update Billing',
      noDismiss: true,
      color: 'negative',
      class: 'bg-white',
      flat: true,
      square: true,
      handler: () => {
        router.push({ name: 'subscriptions' });
      },
    });
  }

  const firstStatement = `Please ${isAdmin ? 'update your credit card on file or ' : ''}contact your team member who is responsible for paying invoices.`;

  const showNotification = () => {
    Notify.create({
      type: 'negative',
      html: true,
      icon: 'warning',
      iconSize: '40px',
      timeout: 0,
      classes: 'dunning-notification q-notification--full-width',
      message: `
          <div class="dunning-notification__header">Your account billing information is out of date.</div>
          <div class="dunning-notification__body">
            <div class="q-mb-xs">${firstStatement} Your account will be deactivated on ${endDate} if we have not received your payment.</div>
            <div class="dunning-notification__expanded"><strong>Subscription</strong>: ${closestDunningSub.plan.name}</div>
          </div>
        `,
      actions,
    });
  };

  storage.onReady(() => {
    let snoozeTime = 0;

    const snoozeTimestamp = storage.get('dunning/snooze');
    if (snoozeTimestamp) {
      snoozeTime = dayjs(snoozeTimestamp).diff(dayjs());
      if (snoozeTime < 0) {
        snoozeTime = 0;
      }
    }

    setTimeout(() => {
      showNotification();
    }, snoozeTime);
  });
}
